import { Component, OnInit, TemplateRef } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from "ngx-toastr";
import { Clipboard } from '@angular/cdk/clipboard';
import { UsersService } from '../services/users.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-wallet-deposit',
  templateUrl: './wallet-deposit.component.html',
  styleUrls: ['./wallet-deposit.component.scss']
})
export class WalletDepositComponent implements OnInit {
  depositeForm: FormGroup;
  depositeidForm: FormGroup;
  depositeAmountForm: FormGroup;
  minAmount: any = 500;
  loginButtonDisable = false;
  file: File = null;
  banktype: any;
  depositmethod: any;
  token: any;
  walletuser: any;
  cardImageBase64: any;
  fileimage: any;
  webimage: any;
  setamount: any;
  amountdata: any;
  createid: any;
  type: any;
  depositdata: any;
  iddeposite: any;
  modalRef: BsModalRef;
  offers: any;
  offerid: any;
  bonus: any;
  maxamount: any;
  maxamounts: any;
  logo: string;
  userdata: any;
  urid: any;
  payment_id: any;
  constructor(
    private _location: Location,
    private clipboard: Clipboard,
    private usersService: UsersService,
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modalService: BsModalService,
  ) {
    this.route.paramMap.subscribe(param => {
      this.type = param.get('type') // (+)Converts string 'id' to number
    });
    this.changeIcon();
  }
  async ngOnInit(): Promise<void> {
    this.createFrom();
    this.createamount();
    this.depositeAForm();
    this.getoffers();
    this.token = sessionStorage.getItem("token");
    this.getuser();
    var getamount = sessionStorage.getItem('depositamount');
    this.amountdata = JSON.parse(getamount);
    // console.log(this.amountdata);
    if (this.amountdata) {
      this.setamount = this.amountdata.coins;
    }
    var data = sessionStorage.getItem('details');
    this.iddeposite = JSON.parse(data);
    var data = sessionStorage.getItem('createid');
    this.createid = JSON.parse(data);


    // console.log(this.createid);

    this.userdata = await JSON.parse(sessionStorage.getItem('userDetails'));
    // console.log(userdata)
    if (this.userdata.details.manager == "PRTCLUB") {
      this.minAmount = 100;
    }
  }
  async findHostName() {
    return (window.location.hostname);
  }

  async changeIcon() {
    const hostname = await this.findHostName();
    const splithostname = hostname.split('.')
    this.logo = splithostname[0];
    console.log(this.logo);

  }
  getamount(event) {
    var amount = event.target.value;
    if (this.userdata.details.manager == "PRTCLUB") {
      if (amount > 99) {
        this.maxamount = amount;
      }
    } else {
      if (amount > 499) {
        this.maxamount = amount;
      }
    }


    // alert(this.maxamount)
    //this.getpamentmethod(this.walletuser);
  }

  async getoffers() {
    const user = await JSON.parse(sessionStorage.getItem('userDetails'));
    // console.log(user)
    var data = { filter: { manager: user?.details?.manager } }
    this.usersService.post_api("get-offer/", data).subscribe((response: any) => {
      // console.log(response);
      let arr = [];
      if (response?.data) {
        for (var i = 0; i < response?.data?.length; i++) {
          let arr_ount = response?.data[i]?.apply_user?.filter((data) => [user?.details?.username].includes(data));
          if (arr_ount?.length < response?.data[i].max_apply || response?.data[i].max_apply == -1) {
            arr.push(response?.data[i])
          }
        }
      }
      // console.log(arr)
      this.offers = arr;
    })
  }

  backClicked() {
    // console.log('test')
    this._location.back();
    this.createamount();
    this.createFrom();
  }
  createamount() {
    this.depositeForm = this.fb.group({
      // amount: ['', [Validators.required, Validators.min(this.minAmount)]],
      image: ['', [Validators.required]],
      utrNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[0-9]{12,22}$/)   // 🔥 12–22 digits only
        ]
      ]
    })

    this.depositeForm.get('utrNumber')?.valueChanges.subscribe(value => {
      if (value) {
        const cleaned = value.replace(/[^0-9]/g, '');
        this.depositeForm.get('utrNumber')?.setValue(cleaned, { emitEvent: false });
      }
    });

  }


  depositeAForm() {
    this.depositeAmountForm = this.fb.group({
      amount: ['', [Validators.required, Validators.min(this.minAmount)]],

      // image: ['', [Validators.required]],
    })

  }
  createFrom() {
    this.depositeidForm = this.fb.group({
      image: ['', [Validators.required]],
    })
  }

  async getuser() {
    const user = await JSON.parse(sessionStorage.getItem('userDetails'));
    this.urid = user.details._id;
    if (this.setamount) {
      this.maxamounts = this.setamount;
      this.getpamentmethod(this.urid);
    }

  }
  async enteramount() {
    if (!this.depositeAmountForm.value.amount) {
      this.toastr.error("Please Enter Amount");
      return;
    } else if (this.depositeAmountForm.value.amount < this.minAmount) {
      this.toastr.error("amount can't be less than " + this.minAmount);
      return;

    } else {

      // console.log(this.depositeAmountForm);
      this.depositeAmountForm.value.amount = this.maxamounts;
      this.maxamounts = this.maxamount;
      // console.log(this.maxamounts);
      const user = await JSON.parse(sessionStorage.getItem('userDetails'));
      this.urid = user.details._id;
      this.getpamentmethod(this.urid);
    }
  }

  getpamentmethod(id) {
    if (!id) return;

    const data = { user_id: id };

    this.usersService.walletPost("user-deposit-method", data).subscribe((response: any) => {

      if (!response?.data) {
        this.depositmethod = [];
        return;
      }

      const amount = Number(this.maxamounts);
      let filtered = response.data.filter((item) => {
        return item.minLimit <= amount && amount <= item.maxLimit;
      });

      let result = [];

      const grouped = {};

      filtered.forEach((item) => {
        if (!grouped[item.paymenttype]) {
          grouped[item.paymenttype] = [];
        }
        grouped[item.paymenttype].push(item);
      });

      Object.keys(grouped).forEach((type) => {
        result.push(...grouped[type]);   // ✅ sab push honge
      });

      this.depositmethod = result;
      // console.log("Filtered Payment Methods:", this.depositmethod);
    });
  }


  async copyToClip(value: string) {
    this.clipboard.copy(value);
    this.toastr.success("Copied !");

  };

  addbank(data) {
    // console.log(data);
    if (data?.paymenttype == 'Gateway' || data?.paymenttype == 'UPI(A)' || data?.paymenttype == 'TriPay') {
      sessionStorage.setItem('paymentData', JSON.stringify(data));
      sessionStorage.setItem('paymentAmount', this.maxamounts);
      this.router.navigate(['paymentgateway']);

    }
    else {
      this.banktype = data;
    }
    // console.log(this.banktype);
  }

  getdays(date) {
    // Set the date we're counting down to
    var countDownDate = new Date(date).getTime();

    // Update the count down every 1 second
    // var x = setInterval(function () {

    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Output the result in an element with id="demo"


    if (distance < 0) {
      // clearInterval(x);
      return "EXPIRED";
    } else {
      return "Valid For " + days + " days " + hours + " hours "
        + minutes + " minutes ";
    }
    // return days + "d " + hours + "h "
    //   + minutes + "m " + seconds + "s ";
    // }, 1000);
  }

  setbonus(data) {
    // console.log(data);
    this.bonus = data
  }
  removeoffer() {
    this.offerid = '';
    this.bonus = '';
  }

  openmodel(success: TemplateRef<any>) {
    // console.log(this.detaile);
    this.modalRef = this.modalService.show(
      success,
      Object.assign({}, { class: 'success modal-lg' })
    );
  }

  onChange(event) {
    let me = this;
    const file = event.target.files[0];

    this.fileimage = file;
    //console.log(this.fileimage);
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      me.cardImageBase64 = reader.result;
      // console.log(reader.result);
      let mimeType = me.cardImageBase64.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
      me.webimage = mimeType;
      // console.log(me.webimage);
    };
    reader.onerror = function (error) {
      // console.log('Error: ', error);
    };
  }

  async depositamount() {
    const user = await JSON.parse(sessionStorage.getItem('userDetails'));
    this.urid = user.details._id;
    if (this.maxamounts != '') {
    } else {
      this.loginButtonDisable = false;
    }
    if (!this.banktype) {
      this.toastr.error("Please Select Payment Method");
      return;
    }
    else if (!this.depositeForm.value.utrNumber) {
      this.toastr.error("Please Enter Utr NUmber");
      return;
    }
    else if (!this.depositeForm.value.image) {
      this.toastr.error("Please Upload Payment screenshot");
      return;
    } else if (this.bonus) {
      this.loginButtonDisable = true;
      // console.log(this.maxamounts);
      var data = new FormData();
      // data.append("type", this.banktype.paymenttype);
      data.append("amount", this.maxamounts);
      data.append("user_id", this.urid);
      data.append("image", this.fileimage);
      data.append("offer_id", this.bonus._id);
      data.append("imagetype", this.webimage);
      data.append("utr_no", this.depositeForm?.value?.utrNumber);
      //data.append("managertype", this.banktype.type);
      //data.append("managerId", '6298db693453531745fc9c8f');
      data.append("methedId", this.banktype._id);
      this.usersService.walletPost("create-deposit-request", data).subscribe((response: any) => {
        this.depositdata = response;
        if (response) {
          this.createFrom();
          this.createamount();
          this.depositeAForm();
          this.cardImageBase64 = '';
          document.getElementById("openModalButton").click();
          this.loginButtonDisable = false;
          this.depositeForm?.reset();
        }

      },
        (error) => {
          if (error.name === 'TimeoutError') {
            this.loginButtonDisable = false;
            this.toastr.error('Server is taking too long to respond.');
          } else {
            this.loginButtonDisable = false;

            this.toastr.error(error?.message || 'Something went wrong.');
          }
        }
      )
      return;
    } else if (!this.bonus) {
      this.loginButtonDisable = true;
      var data = new FormData();
      data.append("amount", this.maxamounts);
      data.append("user_id", this.urid);
      data.append("image", this.fileimage);
      //data.append("offer_id", this.bonus._id);
      // data.append("imagetype", this.webimage);
      //data.append("managertype", this.banktype.type);
      //data.append("managerId", '6298db693453531745fc9c8f');
      data.append("methedId", this.banktype._id);
      data.append("utr_no", this.depositeForm?.value?.utrNumber);
      // console.log(data);
      this.usersService.walletPost("create-deposit-request", data).subscribe((response: any) => {
        this.depositdata = response;
        if (response) {
          this.createFrom();
          this.createamount();
          this.depositeAForm();
          this.cardImageBase64 = '';
          document.getElementById("openModalButton").click();
          this.loginButtonDisable = false;
          this.depositeForm?.reset();
        }
      },
        (error) => {
          if (error.name === 'TimeoutError') {
            this.loginButtonDisable = false;
            this.toastr.error('Server is taking too long to respond.');
          } else {
            this.loginButtonDisable = false;
            this.toastr.error(error?.message || 'Something went wrong.');
          }
        }
      )
    }

  }

  depositidamount() {
    if (this.amountdata.username) {
      // console.log('username');

      if (this.setamount != '') {
      } else {
        this.loginButtonDisable = false;
      }
      if (!this.setamount) {
        this.toastr.error("Please Enter Amount");
        return;
      }
      else if (!this.depositeidForm.value.image) {
        this.toastr.error("Please Upload Payment screenshot");
        return;
      }
      else if (!this.depositeidForm.value.image) {
        this.toastr.error("Please Upload Payment screenshot");
        return;
      } else if (!this.banktype) {
        this.toastr.error("Please select a Payment method");
        return;
      } else if (this.setamount < this.minAmount) {
        this.toastr.error("amount can't be less than " + this.minAmount);
        return;

      } else {
        this.loginButtonDisable = true;
        var data = new FormData();
        // alert('drggddf');
        data.append("type", this.createid.type);
        data.append("typeId", this.createid.typeId);
        data.append("amount", this.setamount);
        data.append("paymentType", this.banktype.paymenttype);
        data.append("image", this.fileimage);
        data.append("user_id", this.urid);
        data.append("imagetype", this.webimage);
        data.append("depositId", this.banktype._id);
        data.append('sites', this.createid._id);
        data.append("utr_no", this.depositeForm?.value?.utrNumber);
        data.append('username', this.amountdata.username);
        data.append("category", 'direct');
        //alert(this.createid._id)
        //return
        this.usersService.walletPost("createMysites", data).subscribe((response: any) => {
          this.depositdata = response;
          if (response) {
            this.createFrom();
            this.createamount();
            this.depositeAForm();
            this.cardImageBase64 = '';
            document.getElementById("openModalButton").click();
            this.loginButtonDisable = false;
            this.depositeidForm?.reset();
            // this.toastr.success(response.message);
          }
        })
      }
    } else {
      if (this.setamount != '') {
      } else {
        this.loginButtonDisable = false;
      }
      if (!this.setamount) {
        this.toastr.error("Please Enter Amount");
        return;
      }
      else if (!this.depositeForm.value.utrNumber) {
        this.toastr.error("Please Enter Utr NUmber");
        return;
      }
      else if (!this.depositeidForm.value.image) {
        this.toastr.error("Please Upload Payment screenshot");
        return;
      } else if (!this.banktype) {
        this.toastr.error("Please select a Payment method");
        return;
      } else if (this.setamount < this.minAmount) {
        this.toastr.error("amount can't be less than " + this.minAmount);
        return;

      } else {
        this.loginButtonDisable = true;
        var data = new FormData();
        data.append("type", this.iddeposite.type);
        data.append("typeId", this.iddeposite.typeId);
        data.append("user_id", this.urid);
        data.append("mysiteId", this.iddeposite._id);
        data.append("amount", this.setamount);
        data.append("paymentType", this.banktype.paymenttype);
        data.append("image", this.fileimage);
        data.append("depositId", this.banktype._id);
        data.append("category", 'direct');
        data.append("utr_no", this.depositeForm?.value?.utrNumber);
        this.usersService.walletPost("depositInsite", data).subscribe((response: any) => {
          this.depositdata = response;
          if (response) {
            this.createFrom();
            this.createamount();
            this.depositeAForm();
            this.cardImageBase64 = '';
            document.getElementById("openModalButton").click();
            this.loginButtonDisable = false;
            this.depositeidForm?.reset();
            // this.toastr.success(response.message);
          }
        })
      }
    }

  }


  ngOnDestroy() {
    sessionStorage.removeItem('depositamount');
  }

}
